import ReceiptDocumentPanel from './ReceiptDocumentPanel';
import {canShowNavReports} from './receiptNavPolicy';
import {hasRole} from '../../../../utils/hasRole';
import ReceiptOverviewLayout from './ReceiptOverviewLayout';
import {financePermissions} from '../../../../utils/financePermissions';
import React, {useState, useEffect, useCallback, useMemo, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {TabView, TabPanel} from 'primereact/tabview';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Button} from "primereact/button";
import {Skeleton} from "primereact/skeleton";
import axios from "axios";

import ReceiptNavNewService from "../../../2.0/_services/receipt/ReceiptNavNewService";
import ReceiptAllocationManager from './ReceiptAllocationManager';
import ReceiptUnavailable from './ReceiptUnavailable';
import ReceiptCorrectionPanel from './ReceiptCorrectionPanel';
import ReceiptRelationListComponent from './ReceiptRelationListComponent';
import ReceiptEvenListComponent from './ReceiptEventListComponent';
import ReceiptNavReportListComponent from './ReceiptNavReportListComponent';
import ReceiptAdvanceSettlementComponent from './ReceiptAdvanceSettlementComponent';

const ReceiptShowComponent = (props) => {

  const {t} = props;
  const {readReceiptAllocations: readAllocations, readTransactions} = financePermissions();
  const [formData, setFormData] = useState({});
  const [partnerAddresses, setPartnerAddresses] = useState([]);
  const [shippingAddress, setShippingAddress] = useState({});
  const [loading, setLoading] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const [partnerId, setPartnerId] = useState(null);
  const [navLoading, setNavLoading] = useState(false);
  const [vats, setVats] = useState([]);
  const [receiptTypeDict, setReceiptTypeDict] = useState({});
  const [navReports, setNavReports] = useState([]);
  const [fileMeta, setFileMeta] = useState(null);
  const [costAllocationSummary, setCostAllocationSummary] = useState([]);
  const [revenueAllocation, setRevenueAllocation] = useState([]);
  const [allocationSummaryLoading, setAllocationSummaryLoading] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [receiptReloadTrigger, setReceiptReloadTrigger] = useState(0);
  const allocationSummaryRequestRef = useRef(0);
  const overviewOnly = formData?.in_review === true;
  useEffect(() => { setActiveTabIndex(0); }, [formData?.id, overviewOnly]);
  // const isSupplierReceipt = formData && (
  //   formData.outgoing === false ||
  //   (formData.receiptType && formData.receiptType.toString().toUpperCase().includes('SUPPLIER')) ||
  //   (formData.receipt_type && formData.receipt_type.toString().toUpperCase().includes('SUPPLIER'))
  // );
  const isSupplierReceipt = ['SUPPLIER_INVOICE', 'SUPPLIER_ADVANCE_INVOICE'].includes(formData?.receipt_type);
  const isCustomerInvoice = ['CUSTOMER_INVOICE', 'CUSTOMER_ADVANCE_INVOICE'].includes(formData?.receipt_type);
  const formatCurrency = (currency, amount) => {
    if (window.App && typeof window.App.currencyFormatter === 'function') {
      return window.App.currencyFormatter(currency || formData.currency, Number(amount || 0));
    }
    return <>{Number(amount || 0)}&nbsp;{currency || formData.currency}</>;
  };

  const priceFormatter = (price) => {
    return <span className={""}>{formatCurrency(formData.currency, price)}</span>
  }

  const receiptNetAmount = Number(formData?.net_amount || 0);
  const costAllocationTotal = useMemo(() => (
    (costAllocationSummary || []).reduce((total, row) => total + Number(row?.amount || 0), 0)
  ), [costAllocationSummary]);
  const revenueAllocationTotal = useMemo(() => (
    (revenueAllocation || []).reduce((total, row) => total + Number(row?.amount || 0), 0)
  ), [revenueAllocation]);

  const formatAllocationPercentage = (amount, currency) => {
    if (
      !Number.isFinite(receiptNetAmount)
      || receiptNetAmount === 0
      || (currency && formData?.currency && currency !== formData.currency)
    ) {
      return '—';
    }

    const percentage = Number(amount || 0) / receiptNetAmount * 100;
    return `${percentage.toLocaleString(props.i18n?.language || undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })}%`;
  };

  const revenueAllocationFooter = (
    <ColumnGroup>
      <Row>
        <Column footer={t('total')} footerStyle={{fontWeight: 600}} />
        <Column
          footer={formatCurrency(formData.currency, revenueAllocationTotal)}
          footerStyle={{textAlign: 'right', fontWeight: 700}}
        />
        <Column
          footer={formatAllocationPercentage(revenueAllocationTotal, formData.currency)}
          footerStyle={{textAlign: 'right', fontWeight: 700}}
        />
      </Row>
    </ColumnGroup>
  );

  const costAllocationFooter = (
    <ColumnGroup>
      <Row>
        <Column footer={t('total')} colSpan={3} footerStyle={{fontWeight: 600}} />
        <Column
          footer={formatCurrency(formData.currency, costAllocationTotal)}
          footerStyle={{textAlign: 'right', fontWeight: 700}}
        />
        <Column
          footer={formatAllocationPercentage(costAllocationTotal, formData.currency)}
          footerStyle={{textAlign: 'right', fontWeight: 700}}
        />
      </Row>
    </ColumnGroup>
  );

  // const vat = (id) => {
  //   if (vats && vats[0]) {
  //     let vat = vats.filter(item => item.id === id)
  //     if (vat[0] && vat[0].acronym) {
  //       return vat[0].acronym
  //     }
  //   }
  // }

  const fetchNavReports = (receiptId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/nav-report",
      params: {
        "search[receipt][operator]": "==",
        "search[receipt][value]": receiptId,
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  };

  const fetchCostAllocationSummary = useCallback((receiptId) => {
    const headers = {
      'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      'App-Network': localStorage.getItem("networkId")
    };
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/cost-allocation/summary/receipt/" + receiptId,
      headers: headers
    });
  }, []);

  const fetchRevenueAllocationSummary = useCallback((receiptId) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/v2/revenue-allocation/summary/receipt/" + receiptId, {
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  }, []);

  const loadAllocationSummaries = useCallback((receiptId, loadCosts, loadRevenues) => {
    const requestId = ++allocationSummaryRequestRef.current;
    if (!readAllocations || !receiptId || (!loadCosts && !loadRevenues)) {
      setCostAllocationSummary([]);
      setRevenueAllocation([]);
      setAllocationSummaryLoading(false);
      return Promise.resolve();
    }

    setAllocationSummaryLoading(true);
    const requests = [];

    if (loadCosts) {
      requests.push(
        fetchCostAllocationSummary(receiptId)
          .then(response => {
            if (requestId !== allocationSummaryRequestRef.current) return;
            const data = response.data?.data || [];
            setCostAllocationSummary(Array.isArray(data) ? data : []);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      );
    } else {
      setCostAllocationSummary([]);
    }

    if (loadRevenues) {
      requests.push(
        fetchRevenueAllocationSummary(receiptId)
          .then(response => {
            if (requestId !== allocationSummaryRequestRef.current) return;
            const data = response.data?.data || [];
            setRevenueAllocation(Array.isArray(data) ? data : []);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      );
    } else {
      setRevenueAllocation([]);
    }

    return Promise.all(requests).finally(() => {
      if (requestId === allocationSummaryRequestRef.current) {
        setAllocationSummaryLoading(false);
      }
    });
  }, [t, fetchCostAllocationSummary, fetchRevenueAllocationSummary, readAllocations]);

  useEffect(() => {
    if (formData?.id) {
      loadAllocationSummaries(formData.id, isSupplierReceipt, isCustomerInvoice);
    }
  }, [formData?.id, isSupplierReceipt, isCustomerInvoice, loadAllocationSummaries]);

  useEffect(() => {
    setLoading(true)
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/vat-rate",
      params: {},
      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
    })
      .then(response => {
        setVats(response.data?.data?.items || [])
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + props.initialValues.id,
        params: {},
        headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
    })
      .then(response => {
        const receipt = response.data?.data;
        setFormData(receipt);
        if (props.onLoad) {
          props.onLoad(receipt);
        }
        const pid =
          receipt?.partner?.id ||
          receipt?.partner_id ||
          receipt?.partnerId ||
          null;
        setPartnerId(pid);
        if (receipt?.file?.id) {
          setFileMeta(receipt.file);
        } else {
          setFileMeta(null);
        }
        props.onLoaded(response.data.data || {});
        // if(response.data.data.partner && response.data.data.partner.id) {
        //   PartneraddressListService('', response.data.data.partner.id)
        //     .then(response => {
        //       let _partnerAddresses = []
        //       response.data.items.map((address, index) => {
        //         _partnerAddresses.push({
        //           id: address.id,
        //           active: address.active,
        //           addressCity: address.addressCity,
        //           addressCountryCode: address.addressCountryCode,
        //           addressDetail: address.addressDetail,
        //           addressPostalCode: address.addressPostalCode,
        //           note: address.note,
        //           type: address.type,
        //           fullAddress: address.addressPostalCode + " " + address.addressCity + " " + address.addressDetail,
        //         })
        //       })
        //       setPartnerAddresses(_partnerAddresses)
        //     })
        // }
        // ReceiptFileGetService(props.initialValues.id)
        //   .then(response => {
        //     setLoading(false)
        //     if (response.data && response.data.file && response.data.file !== null) {
        //       setFile(response.data.file)
        //     }
        //   })
        //   .catch(error => {
        //     setLoading(false)
        //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        //   })




        
        // if ( process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
        //   ['CUSTOMER_INVOICE', 'CUSTOMER_PROFORMA', 'CUSTOMER_ADVANCE_INVOICE'].includes(receipt?.receipt_type) && receipt?.id ){
        //   setNavLoading(true);
        //   fetchNavReports(receipt.id)
        //     .then((response) => {
        //       setNavReports(response.data?.data?.items || response.data?.items || []);
        //     })
        //     .catch(error => {
        //       window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        //     })
        //     .finally(() => setNavLoading(false));
        // }
      })
      .catch(error => {
        setLoading(false)
        if ([404, 410].includes(error.response?.status)) { setUnavailable(true); return; }
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
      axios({
        method: 'get', url: process.env.REACT_APP_API_HOST + "/api/v2/dictionary/receipt-type",
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(res => {
        const map = {};
        (res.data?.data || []).forEach(it => {
          map[it.key] = it.value;
        });
        setReceiptTypeDict(map);
      })
      .catch(error => {
        setLoading(false)
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
    // CompanyLogoShowService(props.initialValues.company.id)
    //   .then(response => {
    //     setCompanyLogo(response.data)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
    //   })
  }, [props.initialValues.id, props.refreshTrigger, receiptReloadTrigger])

  useEffect(() => {
    if (!partnerId) return;
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/partner-address",
      params: { partnerId },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response.data?.data?.items || [];
        setPartnerAddresses(items.map(address => ({
          id: address.id,
          active: address.active,
          addressCity: address.addressCity,
          addressCountryCode: address.addressCountryCode,
          addressDetail: address.addressDetail,
          addressPostalCode: address.addressPostalCode,
          note: address.note,
          type: address.type,
          fullAddress: `${address.addressPostalCode} ${address.addressCity} ${address.addressDetail}`,
        })));
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      });
  }, [partnerId]);



  useEffect(() => {
    if (partnerAddresses && partnerAddresses[0] && formData.partnerShippingAddress && formData.partnerShippingAddress.id) {
      let shippingAddress = partnerAddresses.filter(item => item.id === formData.partnerShippingAddress.id)
      setShippingAddress(shippingAddress[0])
    }
  }, [formData.partnerShippingAddress, partnerAddresses])

  useEffect(() => {
    if (formData && formData.id) {
      window.App.setState({
        props: formData
      });
    }
  }, [formData]);

  const renderAllocationSummaryPlaceholder = (columnCount) => (
    <div className="p-py-2" aria-label={t('loading')}>
      <div className="p-d-flex p-mb-2" style={{gap: '0.75rem'}}>
        {Array.from({length: columnCount}).map((_, index) => (
          <Skeleton key={`header-${index}`} width={`${100 / columnCount}%`} height="1.5rem" />
        ))}
      </div>
      {[0, 1, 2].map(rowIndex => (
        <div key={rowIndex} className="p-d-flex p-mb-2" style={{gap: '0.75rem'}}>
          {Array.from({length: columnCount}).map((_, columnIndex) => (
            <Skeleton
              key={`${rowIndex}-${columnIndex}`}
              width={`${100 / columnCount}%`}
              height="1.15rem"
            />
          ))}
        </div>
      ))}
    </div>
  );

  if (unavailable) return <ReceiptUnavailable />;
  return (
    <>
      {loading === true ? (
        <>
          <span className={"p-d-block p-py-4"} style={{fontSize: '1.5em'}}>
            <i className="pi pi-spin pi-spinner" style={{fontSize: '0.9em'}}></i>
            &nbsp;Betöltés...
          </span>
        </>
      ) : (
        <>
          <ReceiptCorrectionPanel receipt={formData} actionTarget={props.correctionActionTarget} onChanged={() => setReceiptReloadTrigger(value => value + 1)} />
          <div className={"p-grid p-mb-2"}>
            <div className={"p-grid p-mb-2 p-ai-start"} style={{ columnGap: '1.25rem', rowGap: '0.75rem' }}>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnDocumentNumber')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.receipt_number || '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnPartner')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.partner_name || formData?.partner?.name || '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{t('receiptTypeLabel')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.receipt_type
                    ? (receiptTypeDict[formData.receipt_type] ?? formData.receipt_type)
                    : '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{t('receiptGroupLabel')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.receipt_group?.name || '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnIssueDate')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.issue_date ? window.App.formatDateValue(formData.issue_date) : '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnFulfillment')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.receipt_type === 'DELIVERY_NOTE'
                    ? '—'
                    : (formData?.delivery_date ? window.App.formatDateValue(formData.delivery_date) : '—')}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnNetAmount')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.net_amount !== undefined && formData?.net_amount !== null
                    ? priceFormatter(formData.net_amount)
                    : '—'}
                </p>
              </div>
              <div className={"p-col"}>
                <small className={"p-text-uppercase"}>{props.t('columnPaid')}</small>
                <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                  {formData?.is_paid === true ? (
                    <>
                      <i className={"pi pi-check text-success"}></i>&nbsp;{props.t('yes')}
                    </>
                  ) : (
                    <>
                      <i className={"pi pi-times text-danger"}></i>&nbsp;{props.t('none')}
                    </>
                  )}
                </p>
              </div>
            </div>
            {formData && formData?.name && formData && formData.receipt_group?.name &&
            <div className={"p-col"}>
              <small className={"p-text-uppercase"}>
                {t('receiptGroupLabel')}
              </small>
              <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                <>{formData.name}</>
              </p>
            </div>
            }
            {formData && formData.receipt_type &&
            <div className={"p-col"}>
              {/* <small className={"p-text-uppercase"}>
                Típus
              </small> */}
              <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                {['CUSTOMER_INVOICE', 'CUSTOMER_ADVANCE_INVOICE'].includes(formData.receipt_type) &&
                <>
                  {
                    (formData.storno === true || formData.reversed_receipt) &&
                    <>{t('stornoInvoice')}</>
                  }
                  {formData.storno_receipt &&
                  <>{t('stornedInvoice')}</>
                  }
                  {formData.storno !== true && !formData.reversed_receipt && !formData.storno_receipt &&
                  <>{t('receiptInvoice')}</>
                  }
                </>
                }
                {['SUPPLIER_INVOICE', 'SUPPLIER_ADVANCE_INVOICE'].includes(formData.receipt_type) &&
                <>{t('receiptCostInvoice')}</>
                }
                {['CUSTOMER_PROFORMA', 'SUPPLIER_PROFORMA'].includes(formData.receipt_type) &&
                <>{t('receiptFeeRequest')}</>
                }
                {formData.receipt_type === 'DELIVERY_NOTE' &&
                <>{t('receiptDeliveryNote')}</>
                }
              </p>
            </div>
            }
            {formData && formData.partner_type &&
            <div className={"p-col"}>
              <small className={"p-text-uppercase"}>
                {t('partnerType')}
              </small>
              <p className={"p-mt-0 p-mb-0 p-text-bold"}>
                {formData.partner_type === "person" &&
                <>
                  {t('person')}
                </>
                }
                {formData.partner_type === "organisation" &&
                <>
                  {t('organisation')}
                </>
                }
                {formData.partner_type === "other" &&
                <>
                  {t('other')}
                </>
                }
              </p>
            </div>
            }
          </div>
          <hr/>
          <TabView
            className="tabview-header-icon menu"
            renderActiveOnly={true}
            activeIndex={overviewOnly ? 0 : activeTabIndex}
            onTabChange={(event) => {
              setActiveTabIndex(event.index);
              if (event.index === 0 && formData?.id) {
                loadAllocationSummaries(formData.id, isSupplierReceipt, isCustomerInvoice);
              }
            }}
          >
            <TabPanel header={props.t('tabOverview')} leftIcon="pi pi-list">
              <ReceiptOverviewLayout>
                <div>
                  <div style={{width: '100%'}}>
                    <Panel
                      className={"p-mx-auto p-p-5"}
                      style={{
                        width: '100%',
                        maxWidth: '21cm',
                        minHeight: '29cm',
                        borderRadius: '0',
                        margin: '0 auto'
                      }}
                    >
                      <div className={"p-grid"}>
                        <div className={"p-col-12 p-lg-6"}>
                          <h1 className={"p-m-0 p-p-0 p-text-uppercase p-text-right p-text-normal"}>
                            {formData.receipt_type === 'INVOICE' && formData.outgoing === true && (
                              <>{t('receiptInvoice')}</>
                            )}
                            {formData.receipt_type === 'INVOICE' && formData.outgoing === false && (
                              <>{t('receiptCostInvoice')}</>
                            )}
                            {formData.receipt_type === 'DELIVERY_NOTE' && (
                              <>{t('receiptDeliveryNote')}</>
                            )}
                            {formData.receipt_type === 'FEE_REQUEST' && (
                              <>{t('receiptFeeRequest')}</>
                            )}
                          </h1>
                        </div>
                      </div>
                      <div className={"p-grid p-mt-1"}>
                        <div className={"p-col"}>
                          <label>
                            {formData.receipt_type === 'DELIVERY_NOTE' ? (
                              <>{t('deliveryNoteIssueDate')}</>
                            ) : (
                              <>{t('receiptIssueDate')}</>
                            )}
                          </label>
                          <strong className={"p-d-block"}>
                            {formData.issue_date
                              ? window.App.formatDateValue(formData.issue_date)
                              : ''}
                          </strong>
                        </div>

                        {formData.receipt_type !== 'DELIVERY_NOTE' && (
                          <div className={"p-col"}>
                            <label>{t('columnFulfillment')}</label>
                            <strong className={"p-d-block"}>
                              {formData.delivery_date
                                ? window.App.formatDateValue(formData.delivery_date)
                                : ''}
                            </strong>
                          </div>
                        )}

                        {formData.receipt_type !== 'DELIVERY_NOTE' && (
                          <div className={"p-col"}>
                            <label>{props.t('columnPaymentDeadline')}</label>
                            <strong className={"p-d-block"}>
                              {formData.payment_date
                                ? window.App.formatDateValue(formData.payment_date)
                                : ''}
                            </strong>
                          </div>
                        )}

                        {formData.receipt_type !== 'DELIVERY_NOTE' && (
                          <div className={"p-col"}>
                            <label>{t('paymentMethod')}</label>
                            <strong className={"p-d-block"}>
                              {formData.payment_method_name ?? formData.payment_method?.name ?? '—'}
                            </strong>
                          </div>
                        )}

                        <div className={"p-col p-text-right p-text-nowrap"}>
                          <label>
                            {formData.receipt_type === 'DELIVERY_NOTE' ? (
                              <>{t('deliveryNoteNumber')}</>
                            ) : (
                              <>{t('receiptNumber')}</>
                            )}
                          </label>
                          <strong className={"p-d-block"}>
                            {formData.receipt_number}
                          </strong>
                        </div>
                      </div>

                      <div className={"p-grid p-mt-1"}>
                        <div className={"p-col"}>
                          <label>
                            {formData.outgoing === true && <>{t('supplierLabel')}</>}
                            {formData.outgoing === false && <>{t('customerLabel')}</>}
                          </label>

                          <h3 className={"p-m-0 p-p-0"}>
                            {formData.company_name}
                          </h3>

                          {formData.company_address_postal_code}&nbsp;{formData.company_address_city}
                          <br />
                          {formData.company_address_detail}
                          <br />
                          {t('taxNumber')}: {formData.company_vat_number}

                          {formData.company_community_vat_number && (
                            <>
                              <br />
                              {t('communityVatNumber')}: {formData.company_community_vat_number}
                            </>
                          )}

                          {formData.outgoing !== false && <>
                          {(formData.currency !== 'HUF' || !formData.company_bank_account_number) && (formData.company_iban || formData.companyIBAN) ? (
                            <>
                              <br />
                              IBAN: {formData.company_iban || formData.companyIBAN}
                            </>
                          ) : formData.company_bank_account_number ? (
                            <>
                              <br />
                              {t('accountNumber')}: {formData.company_bank_account_number}
                            </>
                          ) : null}

                          {(formData.company_swift || formData.companySwift) && (
                            <>
                              <br />
                              Swift: {formData.company_swift || formData.companySwift}
                            </>
                          )}
                          </>}
                        </div>

                        <div className={"p-col"}>
                          <label>
                            {formData.outgoing === true && <>{t('customerLabel')}</>}
                            {formData.outgoing === false && <>{t('supplierLabel')}</>}
                          </label>

                          <h3 className={"p-m-0 p-p-0"}>
                            {formData.partner_name}
                          </h3>

                          {formData.partner_shipping_address ? (
                            <>
                              {t('shippingAddress')}:&nbsp;
                              {shippingAddress.addressPostalCode}&nbsp;{shippingAddress.addressCity}
                              <br />
                              {shippingAddress.addressDetail}
                            </>
                          ) : (
                            <>
                              {formData.partner_address_postal_code}&nbsp;{formData.partner_address_city}
                              <br />
                              {formData.partner_address_detail}
                            </>
                          )}

                          {formData.partner_vat_number && (
                            <>
                              <br />
                              {t('taxNumber')}: {formData.partner_vat_number}
                            </>
                          )}

                          {formData.partner_community_vat_number && (
                            <>
                              <br />
                              {t('communityVatNumber')}: {formData.partner_community_vat_number}
                            </>
                          )}
                          {formData.outgoing === false && <>
                            {(formData.company_iban || formData.companyIBAN) ? <><br />IBAN: {formData.company_iban || formData.companyIBAN}</>
                              : formData.company_bank_account_number ? <><br />{t('accountNumber')}: {formData.company_bank_account_number}</> : null}
                            {(formData.company_swift || formData.companySwift) && <><br />Swift: {formData.company_swift || formData.companySwift}</>}
                          </>}
                        </div>
                      </div>

                      {formData.receipt_type !== 'DELIVERY_NOTE' ? (
                        <table className={"p-mt-3 w-100"} cellPadding={'5px'} cellSpacing={0}>
                          <tbody>
                            <tr>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-left"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnName')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnQuantity')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnNetUnitPrice')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('vatAbbreviation')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnNetValue')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnVatValue')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('grossValue')}
                              </th>
                            </tr>

                            {formData.items && formData.items.length > 0 ? (
                              formData.items.map((item, index) => (
                                <React.Fragment key={item.id || index}>
                                  <tr>
                                    <td colSpan={7}>
                                      <strong className="p-d-inline-flex p-ai-center">
                                        {item.description}
                                      </strong>
                                    </td>
                                  </tr>
                                  {item.note && (
                                    <tr>
                                      <td
                                        colSpan={7}
                                        style={{paddingBottom: '8px', borderBottom: '1px solid #eee'}}
                                      >
                                        <div
                                          style={{
                                            fontSize: '13px',
                                            color: '#666',
                                            fontStyle: 'normal',
                                            paddingLeft: '10px'
                                          }}
                                        >
                                          {t('comment')}: {item.note}
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td>
                                      &nbsp;
                                    </td>
                                    <td className={"p-text-right"}>
                                      {item.quantity}&nbsp;{item?.unit?.name}
                                    </td>
                                    <td className={"p-text-right"}>
                                      {priceFormatter(item.unit_price)}
                                    </td>
                                    <td className={"p-text-right"}>
                                      {item?.vat_rate?.label}
                                    </td>
                                    <td className={"p-text-right"}>
                                      {priceFormatter(item.net_amount)}
                                    </td>
                                    <td className={"p-text-right"}>
                                      {priceFormatter(item.vat_amount)}
                                    </td>
                                    <td className={"p-text-right"}>
                                      {priceFormatter(item.gross_amount)}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={7}>
                                  <small>{props.t('noItemRecorded')}</small>
                                </td>
                              </tr>
                            )}

                            <tr>
                              <th colSpan={4} className={"p-text-left"} style={{borderTop: '1px solid #ccc'}}>
                                <strong>{t('total')}</strong>
                              </th>
                              <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                <strong>{priceFormatter(formData.net_amount)}</strong>
                              </th>
                              <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                <strong>{priceFormatter(formData.vat_amount)}</strong>
                              </th>
                              <th className={"p-text-right"} style={{borderTop: '1px solid #ccc'}}>
                                <strong>{priceFormatter(formData.gross_amount)}</strong>
                              </th>
                            </tr>

                          </tbody>
                        </table>
                      ) : (
                        <table className={"p-mt-3 w-100"} cellPadding={'5px'} cellSpacing={0}>
                          <tbody>
                            <tr>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-left"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('items')}
                              </th>
                              <th
                                className={"p-text-normal p-text-uppercase p-text-right"}
                                style={{borderBottom: '1px solid #ccc'}}
                              >
                                {t('columnQuantity')}
                              </th>
                            </tr>

                            {formData.items && formData.items.length > 0 ? (
                              formData.items.map((item, index) => (
                                <React.Fragment key={item.id || index}>
                                  <tr>
                                    <td>
                                      <strong>{item.description}</strong>
                                    </td>
                                    <td className={"p-text-right"}>
                                      {item.quantity}&nbsp;{item.unit_name}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2}>
                                  <small>{props.t('noItemRecorded')}</small>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}

                      <div className={"p-grid p-mt-1"}>
                        {formData.projectSummary && formData.projectSummary.length > 0 && (
                          <div className={"p-col"}>
                            <table className={"w-100"}>
                              <tbody>
                                <tr>
                                  <th
                                    className={"p-text-normal p-text-uppercase p-text-left"}
                                    style={{borderBottom: '1px solid #ccc'}}
                                  >
                                    {t('project')}
                                  </th>
                                  <th
                                    className={"p-text-normal p-text-uppercase p-text-right"}
                                    style={{borderBottom: '1px solid #ccc'}}
                                  >
                                    {t('total')}
                                  </th>
                                </tr>

                                {formData.projectSummary.map((item, index) => (
                                  <tr key={item.projectId || index}>
                                    <td>{item.projectName}</td>
                                    <td className={"p-text-right p-text-nowrap"}>
                                      {priceFormatter(item.total_net_amount)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                        {formData.cost_type_summary && formData.cost_type_summary.length > 0 && (
                          <div className={"p-col"}>
                            <table className={"w-100"}>
                              <tbody>
                                <tr>
                                  <th
                                    className={"p-text-normal p-text-uppercase p-text-left"}
                                    style={{borderBottom: '1px solid #ccc'}}
                                  >
                                    {t('columnCostType')}
                                  </th>
                                  <th
                                    className={"p-text-normal p-text-uppercase p-text-right"}
                                    style={{borderBottom: '1px solid #ccc'}}
                                  >
                                    {t('total')}
                                  </th>
                                </tr>

                                {formData.cost_type_summary.map((item, index) => (
                                  <tr key={item.cost_type_id || index}>
                                    <td>{item.cost_type_name}</td>
                                    <td className={"p-text-right p-text-nowrap"}>
                                      {priceFormatter(item.total_net_amount)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>

                      {formData.note && (
                        <div className="p-mt-3" style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}>
                          <strong>{t('columnComment')}: </strong>
                          {formData.note}
                        </div>
                      )}

                      {formData && formData.partner_note && (
                        <p className={"p-mt-3"}>
                          <strong>{props.t('columnComment')}: </strong>
                          {formData.partner_note}
                        </p>
                      )}
                    </Panel>

                  </div>
                </div>

                <div>
                  <div className="p-p-3">
                    {readAllocations && isCustomerInvoice  && (
                      <div className="p-mt-3 p-mb-4">
                        <h3 className="p-mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '0.5rem' }}>
                          <i className="pi pi-list p-mr-2"></i> {t('revenueAllocation')}
                        </h3>
                        {allocationSummaryLoading ? renderAllocationSummaryPlaceholder(3) : (
                          <DataTable
                            value={revenueAllocation}
                            size={localStorage.getItem('scale')}
                            stripedRows
                            responsiveLayout="scroll"
                            emptyMessage={props.t('noResults')}
                            className="p-datatable-sm"
                            footerColumnGroup={revenueAllocationFooter}
                          >
                            <Column field="profit_center" header={t('fieldProfitCenter')}/>
                            <Column
                              header="Összeg"
                              className="p-text-right"
                              alignHeader="right"
                              body={(rowData) => formatCurrency(rowData.currency, rowData.amount)}
                            />
                            <Column
                              header={t('columnPercentage')}
                              className="p-text-right"
                              alignHeader="right"
                              body={(rowData) => formatAllocationPercentage(rowData.amount, rowData.currency)}
                            />
                          </DataTable>
                        )}
                      </div>
                    )}
                    {readAllocations && isSupplierReceipt && (allocationSummaryLoading || costAllocationSummary.length > 0) && (
                      <div className="p-mt-3 p-mb-4">
                        <h3 className="p-mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '0.5rem' }}>
                          <i className="pi pi-list p-mr-2"></i> {t('costAllocation')}
                        </h3>
                        {allocationSummaryLoading ? renderAllocationSummaryPlaceholder(5) : (
                          <DataTable
                            value={costAllocationSummary}
                            size={localStorage.getItem('scale')}
                            stripedRows
                            responsiveLayout="scroll"
                            className="p-datatable-sm"
                            footerColumnGroup={costAllocationFooter}
                          >
                            <Column header={t('columnCostType')} body={(rowData) => rowData.cost_type} />
                            <Column header={t('columnCostCenter')} body={(rowData) => rowData.cost_center} />
                            <Column header={t('columnCostSource')} body={(rowData) => rowData?.cost_source ? t(`costSource${rowData.cost_source}`) : ''} />
                            <Column
                              header={t('columnAmount')}
                              className="p-text-right"
                              alignHeader="right"
                              body={(rowData) => formatCurrency(rowData.currency, rowData.amount)}
                            />
                            <Column
                              header={t('columnPercentage')}
                              className="p-text-right"
                              alignHeader="right"
                              body={(rowData) => formatAllocationPercentage(rowData.amount, rowData.currency)}
                            />
                          </DataTable>
                        )}
                      </div>
                    )}
                    <h3 className="p-mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '0.5rem' }}>
                      <i className="pi pi-history p-mr-2"></i> {t('history')}
                    </h3>
                    <ReceiptEvenListComponent
                      receiptId={props?.initialValues?.id || window.App.state?.props?.id}
                      currency={formData.currency}
                    />
                  </div>
                </div>
              </ReceiptOverviewLayout>
            </TabPanel>
            {!overviewOnly && readAllocations && (isSupplierReceipt ? (
              <TabPanel header={props.t('tabCosts')} leftIcon="pi pi-wallet">
                <div className={"p-p-3"}>
                  <ReceiptAllocationManager receiptId={formData.id} onChanged={() => loadAllocationSummaries(formData.id, isSupplierReceipt, isCustomerInvoice)} />

                </div>
              </TabPanel>
            ) : (
              <TabPanel disabled></TabPanel>
            ))}
            {!overviewOnly && readAllocations && (isCustomerInvoice ? (
              <TabPanel header={props.t('tabRevenues')} leftIcon="pi pi-wallet">
                <div className={"p-p-3"}>
                  <ReceiptAllocationManager receiptId={formData.id} onChanged={() => loadAllocationSummaries(formData.id, isSupplierReceipt, isCustomerInvoice)} />

                </div>
              </TabPanel>
            ) : (
              <TabPanel disabled></TabPanel>
            ))}

            {!overviewOnly && readTransactions && <TabPanel header={props.t('tabFinancialTransactions')} leftIcon="pi pi-credit-card">
              <div className={"p-p-3"}>

                
              </div>
            </TabPanel>}
            {!overviewOnly && <TabPanel header={props.t('tabDocumentImage')} leftIcon="pi pi-file">
              <ReceiptDocumentPanel receipt={formData} file={fileMeta} onFileChanged={file => {
                setFileMeta(file);
                setFormData(previous => ({...previous, file}));
              }} />
            </TabPanel>}

            {!overviewOnly && <TabPanel header={props.t('tabRelatedReceipts')} leftIcon="pi pi-link">
              <div className={"p-grid"}>
                <div className={"p-col"}>
                  <ReceiptRelationListComponent initialValues={formData}/>
                </div>
              </div>
            </TabPanel>}
            {!overviewOnly && ['CUSTOMER_INVOICE', 'SUPPLIER_INVOICE'].includes(formData?.receipt_type) && (
              <TabPanel header={props.t('advanceSettlements')} leftIcon="pi pi-percentage">
                <ReceiptAdvanceSettlementComponent
                  receiptId={formData.id}
                  receipt={formData}
                  onChanged={() => setReceiptReloadTrigger(value => value + 1)}
                />
              </TabPanel>
            )}
            {!overviewOnly && hasRole('ROLE_NAV_REPORT_READ') && process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
              canShowNavReports(formData) &&
              formData?.receipt_number !== 'Vázlat' && (
              <TabPanel header={props.t('tabNavDataReports')} leftIcon="pi pi-file">
                <div className={"p-grid"}>
                  <div className={"p-col"}>
                    <ReceiptNavReportListComponent receiptId={formData.id} navReports={navReports} setNavReports={setNavReports} />
                    <div className={"p-grid p-mt-1"}>
                      <div className={"p-col-12 p-lg-12 p-xl-12 p-text-right p-col-align-center"}>
                        <Button hidden={!hasRole('ROLE_NAV_SYNC')} type="button" label={t('addNavDataReport')} loading={navLoading}
                                icon="pi pi-plus" className="p-button-success p-ml-2"
                                onClick={() => {
                                  setNavLoading(true)
                                  ReceiptNavNewService(formData.id)
                                    .then(response => {
                                      fetchNavReports(formData.id)
                                        .then(response => {
                                          setNavReports(response.data.data?.items)
                                          setNavLoading(false)
                                        })
                                        .catch(error => {
                                          setNavLoading(false)
                                          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                        })
                                    })
                                    .catch(error => {
                                      setNavLoading(false)
                                      window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                                    })
                                }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            )}
          </TabView>
        </>
      )}
    </>
  )
}
export default withTranslation('common')(ReceiptShowComponent);
